export const ISSUES_FOR_PEELING_REQUEST = "ISSUES_FOR_PEELING_REQUEST";
export const ISSUES_FOR_PEELING_SUCCESS = "ISSUES_FOR_PEELING_SUCCESS";
export const ISSUES_FOR_PEELING_FAILED = "ISSUES_FOR_PEELING_FAILED";
